import React from "react";
import PropTypes from "prop-types";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import SendButton from "../../shared/SendButton/SendButton";
//================ STEP 4 ===============

const HandleFreeMessage = ({
                               messageValue,
                               addMessage,
                               addBotMessage,
                               inputDisabled,
                               setInputDisable,
                               setUserInfos,
                               loadingBotMessage,
                               responseBotDelay,
                               setStep,
                               handleChange,
                               sendPlanDemand
                           }) => {
    const handleFreeMessage = (e) => {
        loadingBotMessage(true);
        e.preventDefault();
        addMessage(messageValue);
        setUserInfos(messageValue, "resume");
        setInputDisable(true);
        console.log("test1");
        sendPlanDemand();
        setTimeout(() => {
            loadingBotMessage(false);
            addBotMessage("Merci pour ces informations. Un Care Manager vous rappellera dans les 4h ouvrées pour que vous conveniez ensemble d’une date de rendez-vous. Merci pour votre confiance !");
            setInputDisable(false);
            setStep(5);
        }, responseBotDelay);
    };
    return (
        <ContainerReponse>
            <ChatFormInput
                onSubmit={handleFreeMessage}
                toggleFocusOn={inputDisabled}
                type="text"
                label="Envoyez votre message"
                value={messageValue}
                onChange={handleChange}
                valueToActive={messageValue}
                disabled={inputDisabled ? "disabled" : ""}
                required={true}
            >
                <SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
            </ChatFormInput>
        </ContainerReponse>
    );
};

HandleFreeMessage.propTypes = {
    responseBotDelay: PropTypes.number,
    setStep: PropTypes.func,
    handleChange: PropTypes.func,
    messageValue: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    loadingBotMessage: PropTypes.func,
    sendPlanDemand: PropTypes.func,
    disableDatePicker: PropTypes.func,
};

export default HandleFreeMessage;
